export const OPEN_MODAL = 'modal.open';
export const CLOSE_MODAL = 'modal.close';
